import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { Button, DialogActions, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useFilterStore } from 'context/SelectionStore/Manager/FilterStoreProvider.mager'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import { PRIMARY_COLORS } from 'asterX-UI'
import { Modal } from 'asterX-UI/Modals'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import InfiniteScroll from 'react-infinite-scroll-component'
import FilterPanel from 'pages/Desktop/Selection/Manager/components/FilterPanel/FilterPanel'

import CarData from 'components/Desktop/Car/CarData'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import HeaderBack from 'components/Desktop/HeaderBack'
import TireFilterPanel from 'pages/Desktop/Selection/Manager/components/FilterPanel/TireFilterPanel'
import { useTireFilterStore } from 'context/SelectionStore/Manager/TireFilterStoreContext'
import CarSelectionCard from 'components/Mobile/Car/CarSelectionCard'
import { TireSelectionCard } from 'components/Desktop/Car/CarSelectionCard'
import TireData from 'components/Desktop/Tire/TireData'
import RedirectClient from 'pages/Desktop/Selection/Manager/components/RedirectClient'

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    width: '100%'
  },
  buttonBar: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    paddingTop: 10
  },
  rootDiv: {
    display: 'grid',
    gap: 20,
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    justifyItems: 'center'
  },
  modalButtonBar: {
    gridColumn: '1 / -1'
  }
}))

const CarFilter = () => {
  const [activeCar, setActiveCar] = useState(null)
  const [openSelectedCars, setOpenSelectedCars] = useState(false)
  const classes = useStyles()
  const {
    store: { selectedCars, loading },
    funcs: { handleSelectCar, updateSelectedCars }
  } = useSelectionStore()
  const {
    store: { carsList, countFiltered },
    func: { fetchMoreData }
  } = useFilterStore()

  const handleCarClick = car => {
    setActiveCar(car)
  }
  const handleDemonstrationClose = () => {
    setActiveCar(null)
  }

  const handleOpenSelectedCars = () => {
    setOpenSelectedCars(!openSelectedCars)
  }
  const onSelectCar = () => {
    handleSelectCar(activeCar)
    handleDemonstrationClose()
  }
  return (
    <div className={classes.container}>
      <LoaderBackdrop loading={loading} />
      <FilterPanel />
      {carsList?.length > 0 ? (
        <InfiniteScroll
          dataLength={carsList?.length}
          next={fetchMoreData}
          hasMore={countFiltered > carsList?.length}
          height={'74vh'}
          className={classes.rootDiv}
          style={{
            marginTop: 20
          }}
          loader={
            <p style={{ textAlign: 'center' }}>
              <h4>загрузка...</h4>
            </p>
          }
          endMessage={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '20px 0'
              }}
            >
              <b>Больше нет результатов</b>
            </div>
          }
        >
          {carsList?.map(car => (
            <CarSelectionCard
              car={car}
              isChoosen={!!selectedCars?.find(v => v?.vin === car.vin)}
              onClick={() => handleCarClick(car)}
            />
          ))}
        </InfiniteScroll>
      ) : (
        <div
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            height: '87vh'
          }}
        >
          Ничего нет
        </div>
      )}
      <div className={classes.buttonBar}>
        <Button
          variant={'contained'}
          disabled={selectedCars?.length === 0}
          onClick={handleOpenSelectedCars}
        >
          Выбрано авто
          <ChipStandard
            backgroundColor={PRIMARY_COLORS[200]}
            color={PRIMARY_COLORS[700]}
          >
            {selectedCars?.length}
          </ChipStandard>
        </Button>
        <Button
          variant={'contained'}
          color={'primary'}
          disabled={selectedCars?.length === 0}
          onClick={updateSelectedCars}
        >
          Продолжить
        </Button>
      </div>

      {activeCar?.id && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={activeCar}
          onClose={handleDemonstrationClose}
        >
          <CarData vin={activeCar.vin} onClose={handleDemonstrationClose} />

          <DialogActions>
            <Button
              fullWidth
              size={'small'}
              variant={'contained'}
              color={
                !!selectedCars?.find(v => v.vin === activeCar.vin)
                  ? 'secondary'
                  : 'primary'
              }
              onClick={onSelectCar}
            >
              {!!selectedCars?.find(v => v.vin === activeCar.vin)
                ? 'Исключить'
                : 'Добавить'}
            </Button>
          </DialogActions>
        </Modal>
      )}
      {openSelectedCars && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={openSelectedCars}
          onClose={handleOpenSelectedCars}
        >
          <PageContainerDesktop
            customHeader={
              <HeaderBack onClick={handleOpenSelectedCars}>
                Выбранные авто
                <ChipStandard
                  backgroundColor={PRIMARY_COLORS[200]}
                  color={PRIMARY_COLORS[700]}
                >
                  {selectedCars?.length}
                </ChipStandard>
              </HeaderBack>
            }
          >
            <div className={classes.rootDiv}>
              {selectedCars?.map(car => (
                <CarSelectionCard
                  car={car}
                  isChoosen
                  onClick={() => handleCarClick(car)}
                />
              ))}
              <div className={`${classes.buttonBar} ${classes.modalButtonBar}`}>
                <Button
                  variant={'contained'}
                  color={'primary'}
                  fullWidth
                  onClick={updateSelectedCars}
                >
                  Продолжить
                </Button>
              </div>
            </div>
          </PageContainerDesktop>
        </Modal>
      )}
    </div>
  )
}

export default CarFilter

export const TiresFilter = () => {
  const [isRedirectModalOpen, setIsRedirectModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [activeTire, setActiveTire] = useState(null)
  const [openSelectedTires, setOpenSelectedTires] = useState(false)
  const classes = useStyles()
  const {
    store: { selectedTires, loading, tiresId },
    funcs: { handleSelectTire, updateSelectedTires, addTiresToSale }
  } = useSelectionStore()
  const {
    store: { tireList, countFiltered },
    func: { fetchMoreData }
  } = useTireFilterStore()

  const handleTireClick = tire => {
    setActiveTire(tire)
  }

  const handleDemonstrationClose = () => {
    setActiveTire(null)
  }

  const handleOpenSelectedTires = () => {
    setOpenSelectedTires(!openSelectedTires)
  }

  const onSelectTire = async () => {
    setIsLoading(true)
    handleSelectTire(activeTire)
    const isAlreadySelected = tiresId === activeTire.id

    try {
      await addTiresToSale(isAlreadySelected ? null : activeTire)
      handleDemonstrationClose()
    } catch (error) {
      console.error('Ошибка при обновлении шин:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className={classes.container}>
      <LoaderBackdrop loading={loading || isLoading} />
      <TireFilterPanel />
      {tireList?.length > 0 ? (
        <InfiniteScroll
          dataLength={tireList?.length}
          next={fetchMoreData}
          hasMore={countFiltered > tireList?.length}
          height="74vh"
          style={{ marginTop: 20 }}
          loader={<h4 style={{ textAlign: 'center' }}>загрузка...</h4>}
          endMessage={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '20px 0'
              }}
            >
              <b>Больше нет результатов</b>
            </div>
          }
        >
          <div className={classes.rootDiv}>
            {tireList?.map(tire => (
              <TireSelectionCard
                key={tire.id}
                tire={tire}
                isChoosen={tiresId === tire.id}
                onClick={() => handleTireClick(tire)}
              />
            ))}
          </div>
        </InfiniteScroll>
      ) : (
        <div
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            height: '87vh'
          }}
        >
          Ничего нет
        </div>
      )}
      <div className={classes.buttonBar}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 10
          }}
        >
          <Button
            variant={'contained'}
            onClick={() => setIsRedirectModalOpen(!isRedirectModalOpen)}
          >
            Перенаправить
          </Button>

          <Modal
            open={isRedirectModalOpen}
            onClose={() => setIsRedirectModalOpen(false)}
            fullWidth
          >
            <RedirectClient onClose={() => setIsRedirectModalOpen(false)} />
          </Modal>

          <Button
            variant={'contained'}
            disabled={selectedTires?.length === 0}
            onClick={handleOpenSelectedTires}
          >
            Выбранный комплект
            <ChipStandard
              backgroundColor={PRIMARY_COLORS[200]}
              color={PRIMARY_COLORS[700]}
            >
              {selectedTires?.length}
            </ChipStandard>
          </Button>
        </div>
        <Button
          variant={'contained'}
          color={'primary'}
          onClick={updateSelectedTires}
        >
          Продолжить
        </Button>
      </div>

      {activeTire?.id && (
        <Modal
          fullWidth
          maxWidth="md"
          open={activeTire}
          onClose={handleDemonstrationClose}
        >
          <TireData tire={activeTire} onClose={handleDemonstrationClose} />
          <DialogActions>
            <Button
              fullWidth
              size="small"
              variant="contained"
              color={tiresId === activeTire.id ? 'secondary' : 'primary'}
              onClick={onSelectTire}
            >
              {tiresId === activeTire.id ? 'Исключить' : 'Добавить'}
            </Button>
          </DialogActions>
        </Modal>
      )}
      {openSelectedTires && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={openSelectedTires}
          onClose={handleOpenSelectedTires}
        >
          <PageContainerDesktop
            customHeader={
              <HeaderBack onClick={handleOpenSelectedTires}>
                Выбранный комплект
                <ChipStandard
                  backgroundColor={PRIMARY_COLORS[200]}
                  color={PRIMARY_COLORS[700]}
                >
                  {selectedTires}
                </ChipStandard>
              </HeaderBack>
            }
          >
            <div>
              <TireSelectionCard
                tire={selectedTires}
                isChoosen
                onClick={() => handleTireClick(selectedTires)}
              />

              <div className={`${classes.buttonBar} ${classes.modalButtonBar}`}>
                <Button
                  variant={'contained'}
                  color={'primary'}
                  fullWidth
                  onClick={updateSelectedTires}
                >
                  Продолжить
                </Button>
              </div>
            </div>
          </PageContainerDesktop>
        </Modal>
      )}
    </div>
  )
}
